import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Alert.css";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";
import {
  ShieldCheck,
  TriangleAlert,
  BadgeAlert,
  Ban,
  Info,
  CheckCircle2,
} from "lucide-react";

const Froud_Alert = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const alerts = [
    {
      type: "warning",
      icon: <TriangleAlert size={20} />,
      title: "Never Share Sensitive Information",
      text: "Never share your OTP, Aadhaar, or bank details with anyone on this platform.",
    },
    {
      type: "error",
      icon: <BadgeAlert size={20} />,
      title: "Money Demand is a Red Flag",
      text: "If someone demands money for marriage discussions, report immediately.",
    },
    {
      type: "info",
      icon: <Info size={20} />,
      title: "Cross-Check Profiles Personally",
      text: "Profiles are verified, but always cross-check details personally.",
    },
    {
      type: "warning",
      icon: <Ban size={20} />,
      title: "Protect Your Privacy",
      text: "Avoid sharing private pictures or videos until trust is built.",
    },
    {
      type: "error",
      icon: <BadgeAlert size={20} />,
      title: "Avoid Suspicious Links",
      text: "Do not click on suspicious links sent via chat or email claiming profile upgrades.",
    },
    {
      type: "info",
      icon: <Info size={20} />,
      title: "Meet Safely",
      text: "Meet in public places when meeting a new match for the first time.",
    },
    {
      type: "warning",
      icon: <TriangleAlert size={20} />,
      title: "Do Not Rush Decisions",
      text: "Block and report users who pressure you for quick marriage decisions.",
    },
    {
      type: "error",
      icon: <BadgeAlert size={20} />,
      title: "Fake Claims Are Common",
      text: "Fraudsters may use fake job or property claims to attract users. Stay alert.",
    },
    {
      type: "info",
      icon: <ShieldCheck size={20} />,
      title: "Official Payment Only",
      text: "Community Rishtey never asks for money outside the official payment gateway.",
    },
    {
      type: "success",
      icon: <CheckCircle2 size={20} />,
      title: "Safe Journey Matters",
      text: "By following these safety tips, you can enjoy a secure and trusted matrimonial experience.",
    },
  ];

  return (
    <>
      <LoginHeader />

      <div className="fraud-page">
        {/* Hero Section */}
        <section className="fraud-hero">
          <div className="fraud-hero-overlay"></div>

          <div className="fraud-floating-wrap">
            {["🛡️", "⚠️", "💖", "🔒", "✨", "💍", "❤️", "📌"].map((item, index) => (
              <span key={index} className={`fraud-float fraud-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="fraud-hero-content" data-aos="fade-up">
            <div className="fraud-badge">
              <ShieldCheck size={15} />
              Safety First
            </div>

            <h1 className="fraud-main-title">
              Important <span>Fraud Alerts</span>
            </h1>

            <p className="fraud-subtitle">
              Protect your matrimonial journey with awareness, caution, and trust.
              Your safety is our top priority at Community Rishtey.
            </p>

            <div className="fraud-top-pills">
              <span>🔒 Secure Platform</span>
              <span>✅ Verified Profiles</span>
              <span>⚠️ Report Suspicious Activity</span>
            </div>
          </div>
        </section>

        {/* Alerts Section */}
        <section className="fraud-container">
          <div className="fraud-header" data-aos="fade-up">
            <span className="fraud-section-badge">Community Rishtey Safety Guide</span>
            <h2 className="fraud-title">Stay Safe While Finding Your Perfect Match</h2>
            <p className="fraud-description">
              Please read these important safety alerts carefully to ensure your
              experience remains secure, respectful, and trustworthy.
            </p>
          </div>

          <div className="alert-grid">
            {alerts.map((item, index) => (
              <div
                key={index}
                className={`alert-card ${item.type}`}
                data-aos="zoom-in-up"
                data-aos-delay={index * 70}
              >
                <div className="alert-card-glow"></div>

                <div className={`alert-icon ${item.type}`}>
                  {item.icon}
                </div>

                <div className="alert-content">
                  <h3 className="alert-heading">{item.title}</h3>
                  <p className="alert-text">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="fraud-final-note" data-aos="fade-up">
            <div className="fraud-final-note-icon">
              <ShieldCheck size={22} />
            </div>
            <div>
              <h4>Your Safety Builds Better Relationships</h4>
              <p>
                A secure start leads to a meaningful future. Stay aware, trust your instincts,
                and report anything suspicious immediately.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Froud_Alert;